import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '../config';
import { probatsiyachimi, adminmi, tanlanganTuman, tumanniTanla } from '../foydalanuvchi';
import { tr } from '../til';
import TilTanlash from './TilTanlash';

const styles = {
  sidebar: {
    width: '220px',
    background: '#1a1a2e',
    color: '#fff',
    height: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
    padding: '24px 0',
    display: 'flex',
    flexDirection: 'column',
    // Menyu bandlari ko'payib ketdi — past ekranli noutbuklarda
    // oxirgi bandlar va "Chiqish" tugmasi ko'rinmay qolmasin.
    overflowY: 'auto',
  },
  logo: {
    padding: '0 24px 24px',
    borderBottom: '1px solid #ffffff20',
    marginBottom: '16px',
  },
  logoTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#fff',
  },
  logoSub: {
    fontSize: '12px',
    color: '#ffffff60',
    marginTop: '4px',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '12px 24px',
    color: '#ffffff80',
    textDecoration: 'none',
    fontSize: '14px',
    transition: 'all 0.2s',
  },
  activeLink: {
    color: '#fff',
    background: '#ffffff15',
    borderLeft: '3px solid #4f8ef7',
  },
  logoutBtn: {
    margin: '16px 24px 0',
    padding: '10px',
    background: '#ffffff15',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    cursor: 'pointer',
    marginTop: 'auto',
  }
};

const PROBATSIYA_SAHIFALARI = ['/mahkumlar', '/nazorat', '/sayyor-sud', '/tahlil', '/kunlik-hisobot'];

// Admin uchun tuman tanlash. Admin barcha tumanlarni nazorat qiladi,
// lekin probatsiya ma'lumoti tuman bo'yicha yuritilgani uchun bir vaqtda
// bitta tumanni ko'radi — o'sha tuman xodimi bilan aynan bir xil huquqda.
function TumanTanlash() {
  const [tumanlar, setTumanlar] = useState([]);
  const [tanlangan, setTanlangan] = useState(tanlanganTuman() || '');
  const joy = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API}/districts`, { headers: { authorization: token } })
      .then((r) => {
        const royxat = r.data.filter((t) => t.is_active);
        setTumanlar(royxat);

        // Hali tanlanmagan (yoki tanlangan tuman o'chirilgan) bo'lsa —
        // birinchisini olamiz. Probatsiya sahifasida turgan bo'lsa u
        // "tumanni tanlang" xatosi bilan ochilgan, shuning uchun qayta yuklaymiz.
        const bor = royxat.some((t) => String(t.id) === String(tanlangan));
        if (!bor && royxat[0]) {
          tumanniTanla(royxat[0].id);
          setTanlangan(String(royxat[0].id));
          if (PROBATSIYA_SAHIFALARI.includes(window.location.pathname)) {
            window.location.reload();
          }
        }
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const almashtir = (e) => {
    tumanniTanla(e.target.value);
    setTanlangan(e.target.value);
    // Ochiq sahifa yangi tuman ma'lumotini qaytadan olsin.
    if (PROBATSIYA_SAHIFALARI.includes(joy.pathname)) window.location.reload();
  };

  if (tumanlar.length === 0) {
    return (
      <div style={{ padding: '6px 24px', fontSize: '12px', color: '#aab' }}>
        {tr("Avval \"Tumanlar\" bo'limida tuman qo'shing")}
      </div>
    );
  }

  return (
    <div style={{ padding: '6px 20px 10px' }}>
      <select value={tanlangan} onChange={almashtir} style={{
        width: '100%', padding: '7px 8px', borderRadius: '6px', border: 'none',
        background: '#2a2a44', color: '#fff', fontSize: '13px'
      }}>
        {tumanlar.map((t) => (
          <option key={t.id} value={t.id}>{t.name}</option>
        ))}
      </select>
    </div>
  );
}

function Navbar() {
  const navigate = useNavigate();
  const probatsiya = probatsiyachimi();
  const admin = adminmi();

  const logout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  // Probatsiya xodimida boshqa bo'limlar yopiq (API 403 qaytaradi),
  // shuning uchun menyuda ham ko'rsatilmaydi — bosib xato olmasin.
  if (probatsiya) {
    return (
      <div style={styles.sidebar}>
        <div style={styles.logo}>
          <p style={styles.logoTitle}>{tr("Manguberdi")}</p>
          <p style={styles.logoSub}>{tr("Probatsiya bo'limi")}</p>
        </div>

        <NavLink to="/mahkumlar" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
          ⚖️ {tr("Mahkumlar reyestri")}
        </NavLink>

        <NavLink to="/nazorat" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
          📍 {tr("Masofaviy nazorat")}
        </NavLink>

        <NavLink to="/sayyor-sud" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
          🏛️ {tr("Sayyor sud")}
        </NavLink>

        <NavLink to="/tahlil" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
          📊 {tr("Tahlil")}
        </NavLink>

        <NavLink to="/kunlik-hisobot" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
          📋 {tr("Kunlik hisobot")}
        </NavLink>

        <div style={{ padding: '16px 24px 0', marginTop: 'auto' }}>
          <TilTanlash qorongi />
        </div>
        <button style={{ ...styles.logoutBtn, marginTop: '10px' }} onClick={logout}>
          🚪 {tr("Chiqish")}
        </button>
      </div>
    );
  }

  return (
    <div style={styles.sidebar}>
      <div style={styles.logo}>
        <p style={styles.logoTitle}>{tr("Manguberdi")}</p>
        <p style={styles.logoSub}>{tr("Admin panel")}</p>
      </div>

      <NavLink to="/" end style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        📊 {tr("Dashboard")}
      </NavLink>
      {/* SOS eng tepada — favqulodda signal menyuning oxirida, aylantirib
          topiladigan joyda turmasligi kerak. */}
      <NavLink to="/sos" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        🆘 {tr("SOS signallari")}
      </NavLink>
      <NavLink to="/users" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        👥 {tr("Foydalanuvchilar")}
      </NavLink>
      <NavLink to="/daily-tasks" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        ✅ {tr("Kunlik vazifalar")}
      </NavLink>
      <NavLink to="/taqdimnoma" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        📄 {tr("Taqdimnoma shablonlari")}
      </NavLink>
      <NavLink to="/tests" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        📝 {tr("Testlar")}
      </NavLink>
      <NavLink to="/news" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        📰 {tr("Yangiliklar")}
      </NavLink>
      <NavLink to="/books" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        📚 {tr("Kitoblar")}
      </NavLink>
      <NavLink to="/downloads" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        ⬇️ {tr("Yuklab olishlar")}
      </NavLink>
      <NavLink to="/reminders" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        ⏰ {tr("Eslatmalar")}
      </NavLink>
      <NavLink to="/law-documents" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        ⚖️ {tr("Qonun hujjatlari")}
      </NavLink>
      <NavLink to="/attendance" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        📍 {tr("GPS davomat")}
      </NavLink>
      <NavLink to="/work-zones" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        🗺️ {tr("Ish zonalari")}
      </NavLink>
      <NavLink to="/messages" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        ✉️ {tr("Anonim murojaatlar")}
      </NavLink>
      <NavLink to="/meetings" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        🎙️ {tr("Ovozli yig'ilish")}
      </NavLink>
      <NavLink to="/districts" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
        🏙️ {tr("Tumanlar")}
      </NavLink>
      {admin && (
        <NavLink to="/ilova-versiyalari" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
          📲 {tr("Ilova versiyalari")}
        </NavLink>
      )}

      {admin && (
        <>
          <div style={{
            padding: '16px 24px 4px', fontSize: '11px', letterSpacing: '1px',
            color: '#8a8aa8', textTransform: 'uppercase'
          }}>
            {tr("Probatsiya nazorati")}
          </div>
          <TumanTanlash />
          <NavLink to="/mahkumlar" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
            ⚖️ {tr("Mahkumlar reyestri")}
          </NavLink>
          <NavLink to="/nazorat" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
            📍 {tr("Masofaviy nazorat")}
          </NavLink>
          <NavLink to="/sayyor-sud" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
            🏛️ {tr("Sayyor sud")}
          </NavLink>
          <NavLink to="/tahlil" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
            📊 {tr("Tahlil")}
          </NavLink>
          <NavLink to="/kunlik-hisobot" style={({ isActive }) => ({ ...styles.link, ...(isActive ? styles.activeLink : {}) })}>
            📋 {tr("Kunlik hisobot")}
          </NavLink>
        </>
      )}

      <div style={{ padding: '16px 24px 0', marginTop: 'auto' }}>
        <TilTanlash qorongi />
      </div>
      <button style={{ ...styles.logoutBtn, marginTop: '10px' }} onClick={logout}>
        🚪 {tr("Chiqish")}
      </button>
    </div>
  );
}

export default Navbar;